/* Copyright (c) 2020-present CloudIO Inc */

import { AggregateFunction } from '@cloudio-saas/datasource-types';
import {
  CommonProps,
  defaultCommonProps,
} from '../../layout/Sidebar/panels/PropertiesView/CommonProperties';
import {
  BaseComponentItem,
  ExpressionValue,
} from '../../registry/Component.type';

export interface FusionChartsIOItem extends BaseComponentItem {
  props: FusionChartsIO;
  type: 'FusionChartsIO';
}

export interface FusionChartsIO extends CommonProps {
  dsalias: string;
  // exportFileName: string;
  placeValuesInside?: boolean;
  showLabels?: boolean;
  showLegend?: boolean;
  showShadow?: boolean;
  showValues?: boolean;
  showPercentValues?: boolean;
  showDivLines?: boolean;
  showXAxisValues?: boolean;
  showYAxisValues?: boolean;
  showXAxisLine?: boolean;
  showYAxisLine?: boolean;
  rotateValues?: boolean;
  use3DLighting?: boolean;
  doNotPrefetch?: boolean;
  darkBackGround?: boolean;
  exportEnabled?: boolean;
  slantLabels?: boolean;
  enableSmartLabels?: boolean;
  showTrendlines?: boolean;
  valueOnRight?: boolean;
  dashedLine?: boolean;
  keyAttribute?: string;
  labelAttribute?: string;
  valueAttribute?: string;
  chartHeight?: number;
  chartWidth?: number;
  staggerLines?: number;
  labelStep?: number;
  showCanvasBase?: boolean;
  canvasBaseColor?: string;
  centerLabelFontSize?: number;
  labelFontSize?: number;
  yAxisMaxValue?: number;
  pieYScale?: number;
  pieSliceDepth?: number;
  centerOffsetX?: number;
  centerOffsetY?: number;
  xAxisName?: string;
  yAxisName?: string;
  plotToolText?: string;
  pieRadius?: string;
  doughnutRadius?: string;
  paletteColors?: ExpressionValue;
  caption?: ExpressionValue;
  subCaption?: ExpressionValue;
  defaultCenterLabel?: ExpressionValue;
  labelFormatExpression?: ExpressionValue;
  endValue?: ExpressionValue;
  startValue?: ExpressionValue;
  legendPosition?: 'Bottom' | 'Right';
  labelDisplay?: 'auto' | 'wrap' | 'stagger' | 'rotate';
  valuePosition?: 'inside' | 'outside';
  labelPosition?: 'inside' | 'outside';
  chartType?:
    | 'area2d'
    | 'bar2d'
    | 'bar3d'
    | 'column2d'
    | 'column3d'
    | 'doughnut2d'
    | 'doughnut3d'
    | 'line'
    | 'pie2d'
    | 'pie3d'
    | 'bar'
    | 'area'
    | 'line';
  functionType?: AggregateFunction;
  seriesName?: string;
  displayValue?: string;
  lineColor?: string;
  lineToolText?: string;
  parentYAxis?: 'primary' | 'secondary';
  showIn2D?: boolean;
  lineDashed?: boolean;
  showStacked?: boolean;
  categoryAttribute?: string;
  categoryKeyAttribute?: string;
  orderByAttribute?: string;
}

export const defaultValue: Required<FusionChartsIO> = {
  ...defaultCommonProps,
  chartType: 'column2d',
  // exportFileName: 'chart',
  keyAttribute: '',
  labelAttribute: '',
  valueAttribute: '',
  functionType: 'Count',
  canvasBaseColor: '',
  showCanvasBase: true,
  enableSmartLabels: true,
  showTrendlines: true,
  valueOnRight: true,
  dashedLine: true,
  placeValuesInside: false,
  showLabels: false,
  showLegend: false,
  legendPosition: 'Bottom',
  showShadow: false,
  showValues: false,
  showPercentValues: false,
  showDivLines: true,
  showYAxisValues: true,
  showXAxisValues: true,
  showXAxisLine: false,
  showYAxisLine: false,
  rotateValues: false,
  use3DLighting: false,
  doNotPrefetch: false,
  chartHeight: 1,
  chartWidth: 1,
  xAxisName: '',
  yAxisName: '',
  displayValue: '',
  lineToolText: '',
  lineColor: '#000000',
  labelDisplay: 'auto',
  slantLabels: false,
  dsalias: '',
  staggerLines: 2,
  labelStep: 1,
  paletteColors: { type: 'text', value: '' },
  caption: { type: 'text', value: '' },
  subCaption: { type: 'text', value: '' },
  defaultCenterLabel: { type: 'text', value: '' },
  startValue: { type: 'text', value: '' },
  endValue: { type: 'text', value: '' },
  darkBackGround: false,
  exportEnabled: false,
  yAxisMaxValue: 100,
  plotToolText: '',
  pieRadius: '50%',
  doughnutRadius: '25%',
  centerLabelFontSize: 12,
  labelFontSize: 12,
  labelPosition: 'outside',
  valuePosition: 'outside',
  pieYScale: 60,
  pieSliceDepth: 30,
  centerOffsetX: 0,
  centerOffsetY: 0,
  seriesName: '',
  parentYAxis: 'primary',
  showIn2D: false,
  lineDashed: false,
  showStacked: false,
  categoryAttribute: '',
  categoryKeyAttribute: '',
  orderByAttribute: '',
  labelFormatExpression: { type: 'text', value: '' },
};
